angular.module('unergie.main')
.factory('ModalService', ($state, $uibModal) => {
    const openModal = function (conf, payload, callback) {
        const resolve = {}
        if (payload) {
            _.forEach(payload, (value, key) => {
                resolve[key] = () => value
                return true
            })
        }
        const controller = `${conf.type.split('/').pop()}Ctrl`
        const templateUrl = conf.type.includes('/') ? `/${conf.type}.html` : `/states/${conf.type}/${conf.type}.html`

        const modalInstance = $uibModal.open({
            animation: conf.animation !== false,
            size: conf.size || 'xlg',
            controller,
            templateUrl,
            backdrop: conf.backdrop || true,
            keyboard: conf.backdrop !== 'static',
            windowClass: conf.windowClass,
            resolve,
        })
        return modalInstance.result.then((result) => {
            if (callback) {
                return callback(result)
            }
        })
    }

    return {
        openModal,
    }
})
